import h from "trader-hyperscript";
import { dyn } from "trader.ts/ui";
import { Field, Parsing } from "trader.ts/ui.forms";
import * as style from "./../../styles/style.css.classes";
import { isNil, isString } from "../lib/istype";

export function addInfoUnderField<T>(
  field: Field<T>,
  info: string | ((p: Parsing<T>) => string | null),
): Field<T> {
  return {
    ...field,
    render: () => {
      return (
        <div>
          {field.render()}
          {isString(info) ? (
            <div className={style.formsection_informational}>{info}</div>
          ) : (
            dyn(field.s, (val) => {
              const text = info(val);
              return isNil(text) ? (
                <span></span>
              ) : (
                <div className={style.formsection_informational}>{text}</div>
              );
            })
          )}
        </div>
      );
    },
  };
}
